export default __webpack_public_path__ + "static/media/logo_icon_purple.099d9f92.svg";